import { useLocation, useNavigate } from 'react-router-dom';
import { urlSearchFactory } from '../helpers/urlSearch';

export default () => {
  const { pathname, search } = useLocation();
  return urlSearchFactory({ navigate: useNavigate(), pathname, search });
};
